import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import GridItem from "components/Grid/GridItem.jsx";


import {
  Loop,
  Layers,
  TableChart,
  FilterList,
  Subject,
  ArrowDropDownCircle,
  Dashboard,
  Gesture,
  Widgets,
  Build,
  Details,
  People
} from "@material-ui/icons";
import Divider from "@material-ui/core/Divider";



import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";

class SectionPhoto extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
          
           <h5 className={classes.description}>
              Our capable and skillful Civil & Structure engineering
              professionals offer Seismic or Non‑Seismic design for High‑Rise
              and Low‑Rise Buildings (Residential, Commercial, Educational,
              Healthcare, Agricultural and Industrial Buildings). We also
              provide services related to essential infrastructures such as
              Transport Hubs, Logistic Facilities, Sport & Recreation Complexes,
              Multi-Storey Car Parks, Bored Tunneling, Highway & Road
              Construction, Shallow and Deep Foundations, Temporary Earth
              Retaining Structures, Geotechnical Engineering and Monitoring
              Work.
            </h5>
          </GridItem>
        </GridContainer>

        <br />
       
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Design & Consultancy"
              description="We offer Structural design for Buildings, Civil Engineering Works, Foundations, Specifications, Construction Drawings, Codes of Practice."
              icon={Widgets}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Construction Services"
              description="We offer Building & Other Structures Ground Improvement Works, Pile Load Tests, Instrumentation, Monitoring and Analyzing, Ground Water Controlling, Deep Foundations and Temporary Earth Retaining or Stabilizing Structures, Bored Tunneling and Highway & Road Construction."
              icon={Build}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Project Management"
              description="We offer Pre-contract (Tendering Stage) and  Post-contract (Project Stage)."
              icon={People}
              iconColor="danger"
              vertical
            />
          </GridItem>
        </GridContainer>
        <Divider />
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Design & Consultancy</h2>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Structural Design for Buildings"
                description="We offer Residential, Commercial, Agricultural, Office, Educational, Medical, Government, Military, Religious, Transport & Industrial Buildings, Parking Structures & Logistic Facility Infrastructures."
                icon={Dashboard}
                iconColor="danger"
                vertical
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Construction Related  Works"
                description="We offer Stabilizing Structures for Deep Excavation, Temporary Earth Retaining Walls, Passenger Hoist Foundations, Tower Crane Foundations, Scaffoldings."
                icon={Layers}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Civil Engineering Works"
                description="We offer Drains and Minor Sewers."
                icon={Build}
                iconColor="danger"
                vertical
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Foundations"
                description="We offer Shallow/Deep Foundations, Earth Retaining Systems for Deep Excavations such as Diaphragm Walls, Secant Bored Piles, Contiguous Bored Piles."
                icon={Layers}
                iconColor="danger"
                vertical
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Specifications"
                description="We provide structural specifications complying with relevant standards or codes of practice."
                icon={Details}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Construction Drawings"
                description="We offer provision of structural detailed drawings for construction works."
                icon={Gesture}
                iconColor="danger"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>

        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <InfoArea
              title="Codes of Practice"
              description="We comply with International Standards or Codes of Practice (CP) including Local CP with Statutory Authorities Requirements from Relevant City Development Committees, High-Rise Inspection Committee (HIC) & CQHP."
              icon={Subject}
              iconColor="danger"
              vertical
            />
          </GridItem>
        </GridContainer>
        <Divider />
  
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Construction</h2>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Building & Other Structures"
                description="We offer RC, Steel, Precast, Prestressed & Composite Structures."
                icon={Dashboard}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Ground Water Controlling"
                description="We offer Deepwell, Well Point & Relief Well Systems, Pumping Technique, Cut-Off Wall Technique."
                icon={Details}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Pile Load Tests"
                description="We offer Instrumented Ultimate Load Tests, Static Working Load Tests, Pile Integrity & Pile Dynamic Load Tests."
                icon={Build}
                iconColor="danger"
                vertical
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Instrumentation, Monitoring and Analyzing"
                description="We offer  Structure Monitoring Instruments such as Building Settlement Marker, 3D Prisms, Strain Gauge, Tilt Meter, Ground Monitoring Instruments such as Piezometer, Water Stand Pipe, Rock Extensometer, In-Wall & In-Soil Inclinometer, Ground Settlement Marker, Utilities Settlement Marker."
                icon={Loop}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Ground Improvement Works"
                description="We offer Deep Cement Mixing, Jet Grouting, Tam Grouting, Wet Soil Mixing."
                icon={Layers}
                iconColor="danger"
                vertical
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Temporary Earth Retaining or Stabilizing Structures"
                description="We offer Installation of Sheet Pile, H Pile, Soldier Pile/Kingpost, Excavation & Earth Control Management, Temporary Strutting System (RC/Steel), Cross Wall/Buttress Wall."
                icon={FilterList}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Deep Foundations"
                description="We can offer Construction of Diaphragm Wall, Barrette Pile, Bored Pile, Secant Bored Pile, Contiguous Bored Pile & Press Pile, Confirmation of Actual Founding Level, Verification of Founding Rock/Soil Properties (Geotechnical Parameters, Strata Condition)."
                icon={Details}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Bored Tunnelling"
                description="We offer Tunnel Excavation by using Earth Pressure Balance (EPB) Machine & Slurry Type Machine."
                icon={ArrowDropDownCircle}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Highway & Road Construction"
                description="We offer Multi-Lane Expressways, Flexible/Rigid Pavements, Pavement Markings, Road & Related Facilities (Culverts, Drains, Slip Roads, Carriage Ways), Footpaths, Precast Concrete Kerbs & Dividers, Signages."
                icon={TableChart}
                iconColor="danger"
                vertical
              />
            </GridItem>
          </GridContainer>
          <Divider />
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <h2 className={classes.title}>
                Project Management & Supervision
              </h2>
            </GridItem>
          </GridContainer>
          <div>
            <GridContainer>
              <GridItem xs={12} sm={6}>
                <InfoArea
                  title="Pre-contract (Tendering Stage)"
                  description="We offer preparation of Tender Costing & Tender Documents, Schematic Estimated Cost & Project Schedule, Quantity Measurement."
                  icon={Dashboard}
                  iconColor="danger"
                  vertical
                />
              </GridItem>
              <GridItem xs={12} sm={6}>
                <InfoArea
                  title="Post-contract (Project Stage)"
                  description="We can offer Coordination & Managing with Contractors & Clients, Managing & Negotiating Progress Claims, Variation Orders at Construction Stage, Conduct Inspection, Verification & Identification of Completed Work."
                  icon={Details}
                  iconColor="danger"
                  vertical
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>

      
      </div>
    );
  }
}

export default withStyles(workStyle)(SectionPhoto);



// WEBPACK FOOTER //
// ./src/views/CivilPage/Sections/SectionPhoto.jsx